import { Close, DeleteOutline } from '@mui/icons-material';
import { Box, DialogContent, Divider, Grid, IconButton, Stack, Typography } from '@mui/material';
import { ClientControllerState, ClientControllerAction } from '../../controller/client-controller';
import { formatDateStr } from '../../../../utils/date-format';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../../alert/data/custom.alert.icon';

const ClientModalInfo = ({
  ctrl,
  alert,
}: {
  ctrl: ClientControllerState & ClientControllerAction;
  alert: CustomAlertAction & CustomAlertState;
}) => {
  return (
    <DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4">ຂໍ້ມູນຜູ້ໃຊ້ງານ</Typography>

        <IconButton onClick={() => ctrl?.onHandleModal(null)}>
          <Close />
        </IconButton>
      </Box>

      <Divider sx={{ mb: 3, mt: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Stack spacing={2}>
            <Stack>
              <Typography>ຊື່ຜູ້ໃຊ້ງານ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.selectedItem?.first_name} {ctrl.selectedItem?.last_name}
              </Typography>
            </Stack>

            <Stack>
              <Typography>ຕຳແໜ່ງ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.listPosition?.find((p) => p.uuid === ctrl.selectedItem?.position_id)
                  ?.position_name_la ??
                  ctrl.selectedItem?.position_id ??
                  '-'}
              </Typography>
            </Stack>

            <Stack>
              <Typography>ອົງກອນ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.listMinistry?.find((m) => m.uuid === ctrl.selectedItem?.ministry_id)
                  ?.title_la ??
                  ctrl.selectedItem?.ministry_id ??
                  '-'}
              </Typography>
            </Stack>
            <Stack>
              <Typography>ບົດບາດຜູ້ໃຊ້:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.listRoles?.find((r) => r.id === ctrl.selectedItem?.role_id)?.role_name ?? '-'}
              </Typography>
            </Stack>
            <Stack>
              <Typography>ສະຖານະຜູ້ໃຊ້:</Typography>
              <Typography
                variant="body2"
                sx={{ color: ctrl.selectedItem?.status ? 'green' : 'red' }}
              >
                {ctrl.selectedItem?.status ? 'ACTIVE' : 'INACTIVE'}
              </Typography>
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={6}>
          <Stack spacing={2}>
            <Stack>
              <Typography>ອີເມວ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.selectedItem?.email}
              </Typography>
            </Stack>

            <Stack>
              <Typography>ເບີໂທ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.selectedItem?.phone}
              </Typography>
            </Stack>

            <Stack>
              <Typography>ເພີ່ມເມື່ອ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {ctrl.createdByName ?? ctrl.selectedItem?.created_by ?? '-'} |{' '}
                {formatDateStr(new Date(ctrl.selectedItem?.created_at ?? Date.now()))}
              </Typography>
            </Stack>

            <Stack>
              <Typography>ອັບເດດລ້າສຸດ:</Typography>
              <Typography variant="body2" sx={{ color: 'grey' }}>
                {formatDateStr(new Date(ctrl.selectedItem?.updated_at ?? Date.now()))}
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Divider sx={{ mb: 3, mt: 2 }} />
      <button
        style={{
          border: 'none',
          padding: '12px 46px 12px 46px',
          borderRadius: 30,
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'red',
        }}
        onClick={() =>
          alert.handleCustomAlert({
            title: 'ລົບຂໍ້ມູນ',
            message: 'ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?',
            type: CustomAlertType.WARNING,
            icon: CustomAlertIcons.deleteConfirm,
            negText: 'ກັບຄືນ',
            posText: 'ຢືນຢັນ',
            onPositive: () => {
              ctrl.onDelete(ctrl?.selectedItem?.uuid ?? '');
              alert.handleCustomAlert(null);
            },
          })
        }
      >
        <DeleteOutline />
        ລຶບບັນຊີ
      </button>
    </DialogContent>
  );
};

export default ClientModalInfo;
